<template lang="pug">
  v-dialog(v-model="value" max-width="580px" persistent)
    v-card.rounded-card(v-if="statusData" data-cy="registration-status-modal")
      v-card-title.pb-0
        v-layout(row justify-center)
          v-flex(xs12)
            h1.primary--text.text-xs-center.font-weight-thin.title-pad {{ titleText }}
      v-card-text.pt-2.pb-0
        v-layout(column align-center)
          v-flex(xs12)
            v-icon.my-3(size=60) {{ statusData.icon }}
        v-layout(row)
          v-flex(xs12)
            .xs12(v-for="line in statusData.content" :style="contentStyle" v-html="line")
        v-layout(v-if="statusData.buttonLabel" column align-center)
          v-flex(xs12)
            v-btn.action-btn.text-xs-center(
              color="primary"
              @click="handleAction(statusData.actionCode)"
            ) {{ statusData.buttonLabel }}
        v-layout(v-if="statusData.actionWarning" row)
          v-flex(xs12)
            div.red--text(v-html="statusData.actionWarning" :style="contentStyle")
      v-layout.mt-2(column align-center)
        v-flex.mt-2(xs12)
          v-btn.text-xs-center(color="primary" flat @click="$emit('close')") Close
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import { ACTION_CODES } from '../../Text/config/registrationStatus';
import { STEPS_SOLE_PROPRIETOR } from '@/a2p/config';
import { standard, lowStandard, soleProprietor } from '../../Text/config/consoleSteps';

export default {
  name: 'RegistrationStatusModal',
  props: {
    openDialog: false,
  },
  data() {
    return {
      checker: {},
    };
  },
  async mounted() {
    if (!this.has10dlcRegister || !this.isCompleted) {
      await this.checkFor10dlcRegister();
    }
    this.startChecker();
  },
  beforeDestroy() {
    clearInterval(this.checker);
  },
  computed: {
    ...mapState('conversations', [
      'registrationStatus10dlc',
      'registrationType10dlc',
      'registrationStatusData10dlc',
      'has10dlcRegister',
    ]),
    ...mapGetters('conversations', ['statusData']),
    titleText() {
      return 'Registration Status';
    },
    value: {
      get() {
        return this.openDialog;
      },
      set() {
        this.$emit('close');
      },
    },
    isCompleted() {
      return this.registrationStatus10dlc === 'campaign_completed';
    },
    errorMessage() {
      if (this.registrationStatusData10dlc && this.registrationStatusData10dlc.description) {
        return `: ${this.registrationStatusData10dlc.description}`;
      }
      
      if (
        this.registrationStatusData10dlc &&
        this.registrationStatusData10dlc[0] &&
        this.registrationStatusData10dlc[0].description
      ) {
        return `: ${this.registrationStatusData10dlc[0].description}`;
      }
      return '';
    },
    errorMailString() {
      let subject = encodeURIComponent('Texting Console: Registration Error');
      let body = encodeURIComponent(
        ''.concat('I am getting this registration error in the Texting Console', this.errorMessage),
      );

      if (this.statusData.errorCase && this.statusData.supportMail) {
        const { subject: customSubject, body: customBody } = this.statusData.supportMail
        subject = encodeURIComponent(customSubject);
        body = encodeURIComponent(customBody);
      }

      return ''.concat('mailto:support@liondesk.com?subject=', subject, '&body=', body);
    },
    isStandardOrLowVolume() {
      return this.registrationType10dlc === lowStandard || this.registrationType10dlc === standard
    },
    contentStyle() {
      if (this.registrationType10dlc === soleProprietor && this.registrationStatus10dlc === 'brand_otp_pending') {
        return {};
      }
      return { 'text-align': 'center' };;
    },
  },
  methods: {
    ...mapActions('conversations', ['checkFor10dlcRegister']),
    ...mapActions('registerSoleProprietorA2p', ['setStep']),
    async checkStatus() {
      if (this.isCompleted) {
        clearInterval(this.checker);
        return;
      }

      await this.checkFor10dlcRegister(this.registrationType10dlc);
    },
    startChecker() {
      this.checker = setInterval(this.checkStatus, 5000);
    },
    handleAction(action) {
      switch (action) {
        case ACTION_CODES.FIX_TEXT_MESSAGE_TYPES:
          if (this.isStandardOrLowVolume) {
            this.$emit('soft-close');
            this.$router.push('/a2p-lowstandardbrand-registration#campaign');
            break;
          }
          this.setStep(STEPS_SOLE_PROPRIETOR.CAMPAIGN);
          break;
        case ACTION_CODES.START_REGISTRATION_AGAIN:
        case ACTION_CODES.FIX_IDENTITY_VERIFICATION:
          if (this.isStandardOrLowVolume) {
            this.$emit('soft-close');
            this.$router.push('/a2p-lowstandardbrand-registration');
            break;
          }
          this.setStep(STEPS_SOLE_PROPRIETOR.SOLE_PROPRIETOR);
          break;
        case ACTION_CODES.GET_SUPPORT_ASSISTANCE:
        case ACTION_CODES.REQUEST_EVALUATION_SUPPORT:
        case ACTION_CODES.REQUEST_RESETTING_SUPPORT:
          window.open(this.errorMailString);
          break;
      }
    },
  },
};
</script>

<style scoped>
.action-btn {
  text-transform: none;
}

.rounded-card {
  border-radius: 10px;
}

.title-pad {
  padding-left: 40px;
  padding-right: 40px;
  margin-top: -20px;
}

.v-card {
  padding-top: 5%;
  padding-left: 10px;
  padding-right: 10px;
}
</style>
